<template>
  <div>
    <section></section>
    <!-- Sección para mostrar un mensaje de confirmación si el formulario se envió con éxito -->
    <section
      v-if="submittedSuccessfully && pageStatus == PAGESTATUS_SUCCESS"
      class="alert-component"
    >
      <ConfirmationComponent
        :title="$t('directService.confirmation-title')"
        :subtitle="$t('directService.confirmation-subtitle')"
        :ctatext="$t('directService.confirmation-text')"
      ></ConfirmationComponent>
    </section>
    <!-- Sección principal del formulario -->
    <div
      v-if="pageStatus == PAGESTATUS_FORM"
      class="main-background direct-service"
    >
      <div class="main-header">
        <h1>{{ $t("directService.title") }}</h1>
      </div>
      <v-container class="servicio-directo">
        <div class="section-heading mt-3">
          <h2>{{ $t("directService.title1") }}</h2>
          <p class="ae-description">
            {{ $t("directService.informationFields") }}
          </p>
        </div>
        <!-- Componente de pasos verticales -->
        <v-stepper v-model="actualStep" vertical class="elevation-0">
          <v-stepper-step step="1" editable>
            {{ $t("directService.customerData.title") }}
          </v-stepper-step>
          <!-- Contenido del primer paso: Formulario del cliente -->
          <v-stepper-content step="1">
            <ValidationObserver ref="clientForm" tag="form" v-slot="{ valid }">
              <ClientForm
                ref="clientFormulario"
                :name="name"
                :surname="surname"
              />
              <!-- Mostrar mensaje de error si hay errores de validación -->
              <div v-if="showError && !valid" class="error-message">
                <img
                  class="alert-error"
                  src="@/assets/alert.svg"
                  alt="Custom card Img"
                />{{ $t("directService.alert-error") }}
              </div>
              <div class="py-3">
                <v-btn
                  class="my-0 mx-auto d-block"
                  color="primary"
                  fab
                  @click="goToNextStep(valid)"
                >
                  <v-icon dark>mdi-arrow-down</v-icon>
                </v-btn>
              </div>
            </ValidationObserver>
          </v-stepper-content>

          <v-stepper-step step="2">
            {{ $t("directService.suitcaseData.title") }}
          </v-stepper-step>
          <!-- Contenido del segundo paso: Formulario de la maleta -->
          <v-stepper-content step="2" complete>
            <ValidationObserver
              ref="suitcaseForm"
              tag="form"
              v-slot="{ valid: isStep2Valid }"
            >
              <div v-if="baggageForm && suitCases.length">
                <SuitcaseForm
                  ref="suitcaseFormulario"
                  contactId
                  :suitCases="suitCases"
                />
              </div>
              <!-- Checkbox para aceptar las condiciones del servicio -->
              <VCheckboxWithValidation
                class="checkbox-style"
                v-model="conditionsCheck"
                :label="`Acepto las condiciones del Servicio,
      que establecen la sustitución de una maleta de similares características a las especificadas en este formulario,
      sin garantizar medidas exactas, marca, modelo o color.`"
              />
              <!-- Checkbox para aceptar la política de privacidad -->
              <VCheckboxWithValidation
                class="checkbox-style"
                v-model="policyCheck"
              >
                <template v-slot:label>
                  <div class="checkbox-label-container">
                    <span class="checkbox-label-text">
                      Confirmo que he leído y acepto la
                      <a
                        href="https://www.aireuropa.com/es/es/aea/informacion-para-volar/condiciones/politica-de-privacidad.html"
                        target="_blank"
                        @click.stop
                      >
                        Política de privacidad
                      </a>
                    </span>
                  </div>
                </template>
              </VCheckboxWithValidation>

              <!-- Texto de "Más información" -->
              <div class="additional-info-container">
                <div v-if="showMoreInfo" class="more-info-text">
                  <div class="more-info-text-title0">
                    <span>INFORMACIÓN BÁSICA DE PROTECCIÓN DE DATOS:</span>
                  </div>
                  <div class="more-info-text0">
                    <span>
                      Conforme a lo dispuesto en el Reglamento (UE) 2016/679 del
                      Parlamento Europeo y del Consejo, de 27 de abril de 2016
                      (RGPD) y en la Ley Orgánica 3/2018, de 5 de diciembre, de
                      Protección de Datos Personales y garantía de los derechos
                      digitales (LOPDGDD), le informamos que los datos
                      personales que nos facilite serán tratados por:</span
                    >
                  </div>
                  <div class="more-info-text-title">
                    <span
                      >Responsable:
                      <span class="more-info-text"
                        >AIR EUROPA LÍNEAS AÉREAS, S.A.U
                      </span></span
                    >
                  </div>
                  <div class="more-info-text-title">
                    <span>
                      Finalidades Principales:
                      <span class="more-info-text">
                        gestionar las consultas, quejas/incidencias,
                        reclamaciones y solicitudes realizadas por parte del
                        cliente y/o pasajero, así como cualquier otra
                        comunicación (felicitación y sugerencias).</span
                      ></span
                    >
                  </div>
                  <div class="more-info-text-title">
                    <span
                      >Legitimación:
                      <span class="more-info-text">
                        relación contractual.</span
                      ></span
                    >
                  </div>
                  <div class="more-info-text-title">
                    <span
                      >Conservación:
                      <span class="more-info-text">
                        durante la relación comercial, y permanecerán bloqueados
                        durante 6 años tras la finalización de la misma.</span
                      ></span
                    >
                  </div>
                  <div class="more-info-text-title">
                    <span
                      >Destinatarios:
                      <span class="more-info-text">
                        no se comunicarán a terceros, salvo obligación legal, o
                        para la prestación del servicio (encargados de
                        tratamiento).</span
                      ></span
                    >
                  </div>
                  <div class="more-info-text-title">
                    <span
                      >Derechos:
                      <span class="more-info-text"
                        >acceso, rectificación, supresión, oposición,
                        portabilidad y limitación de sus datos, así como el
                        derecho a retirar el consentimiento prestado
                        dirigiéndose a nuestro Delegado de Protección de Datos:
                        <a href="mailto:delegadopd@aireuropa.com"
                          >delegadopd@aireuropa.com</a
                        ></span
                      ></span
                    >
                  </div>
                  <div class="more-info-text0">
                    <span>
                      En cualquier situación, tiene derecho a presentar una
                      reclamación ante la Agencia Española de Protección de
                      Datos
                      <a href="http://www.aepd.es" target="_blank"
                        >(http://www.aepd.es)</a
                      >
                    </span>
                  </div>

                  <div class="more-info-text-title">
                    <span
                      >Información adicional:
                      <span class="more-info-text"
                        >puede consultar información adicional en la
                        <a
                          href="https://www.aireuropa.com/es/es/aea/informacion-para-volar/condiciones/politica-de-privacidad.html"
                          target="_blank"
                          >Política de privacidad</a
                        ></span
                      ></span
                    >
                  </div>
                </div>
                <span @click="toggleMoreInfo" class="more-info-link">
                  {{ showMoreInfo ? "Menos información" : "Más información" }}
                </span>
              </div>
              <!-- Mostrar mensaje de error si hay errores de validación -->
              <div v-if="showError && !isStep2Valid" class="error-message">
                <img
                  class="alert-error"
                  src="@/assets/alert.svg"
                  alt="Custom card Img"
                />{{ $t("directService.alert-error") }}
              </div>
              <div
                v-if="!isStep2Valid || !conditionsCheck"
                class="validation-message"
              >
                Todos los datos obligatorios deben estar informados
              </div>
              <!-- Botón para enviar el formulario -->
              <div class="py-3">
                <v-btn
                  class="my-0 mx-auto d-block"
                  color="primary"
                  :disabled="!isStep2Valid || !conditionsCheck"
                  @click="submitFormData"
                  dark
                  large
                >
                  <span class="mr-1">Enviar</span>
                  <v-icon dark>mdi-send</v-icon>
                </v-btn>
                <!-- Texto de advertencia -->
                <div>
                  <div class="warning-text">
                    Advertencia:
                    <br />
                    La información contenida en este mensaje y/o archivo(s)
                    adjunto(s), enviada desde AIR EUROPA LÍNEAS AÉREAS, S.A.U.,
                    es confidencial/privilegiada y está destinada a ser leída
                    sólo por la(s) persona(s) a la(s) que va dirigida. Si usted
                    lee este mensaje y no es el destinatario señalado, el
                    empleado o el agente responsable de entregar el mensaje al
                    destinatario, o ha recibido esta comunicación por error, le
                    informamos que está totalmente prohibida, y puede ser
                    ilegal, cualquier divulgación, distribución o reproducción
                    de esta comunicación, y le rogamos que nos lo notifique
                    inmediatamente y nos devuelva el mensaje original a la
                    dirección arriba mencionada. Gracias.
                  </div>
                </div>
              </div>
            </ValidationObserver>
          </v-stepper-content>
        </v-stepper>
      </v-container>
    </div>
  </div>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import SuitcaseForm from "./SuitcaseForm.vue";
import ClientForm from "./ClientForm.vue";
import VCheckboxWithValidation from "@/components/dynamic/VCheckboxWithValidation.vue";
import { mapStores } from "pinia";
import { useTokenStore } from "@/stores/tokenStore";
import { useUiStore } from "@/stores/uiStore";
import Api from "@/api/api.js";
import ConfirmationComponent from "./ConfirmationComponent.vue";
import { parsePhoneNumber } from "libphonenumber-js";

export default {
  name: "DirectService",
  components: {
    ValidationObserver,
    SuitcaseForm,
    ClientForm,
    VCheckboxWithValidation,
    ConfirmationComponent,
  },
  data: () => ({
    defaultValues: null,
    valid: true,
    config: null,
    actualStep: 1,
    steps: 2,
    pir: null,
    error: false,
    contactId: null,
    suitCases: [],
    conditionsCheck: false,
    policyCheck: false,
    baggageForm: false,
    submittedSuccessfully: false,
    caseId: null,
    PAGESTATUS_FORM: 0,
    PAGESTATUS_SUCCESS: 1,
    PAGESTATUS_LOADERROR: 2,
    // PAGESTATUS_CUSTOMERROR: 4,
    // PAGESTATUS_EXPIRED: 7,
    pageStatus: null,
    name: null,
    surname: null,
    showError: false,
    showMoreInfo: false,
  }),
  watch: {
    // Observar cambios en las maletas y actualizarlas
    suitCases(t) {
      this.suitCase = t;
    },
    // Observar cambios en los pasos y actualizar el paso actual si es necesario
    steps(val) {
      if (this.actualStep > val) {
        this.actualStep = val;
      }
    },
    // Observar cambios en la propiedad editable del paso y restablecer el paso actual a 1 si es true
    "step.editable": function (newVal) {
      // Si 'editable' es true, establece 'actualStep' a 1
      if (newVal) {
        this.actualStep = 1;
      }
    },
  },
  computed: {
    ...mapStores(useTokenStore, useUiStore),
    // Computar si el token ha expirado
    isExpiredToken() {
      return this.tokenStore?.isExpiredToken;
    },
  },
  created() {
    // if (!this.tokenStore.number) {
    //   this.error = true;
    // }
    // this.pageStatus = this.PAGESTATUS_EXPIRED;
    // Obtener los parámetros de la ruta y asignarlos al nombre y apellido si existen
    const { params } = this.tokenStore.$state;
    if (params?.name && params?.surname) {
      this.name = params.name;
      this.surname = params.surname;
    }
    // Verificar si el token ha expirado y manejar el error

    this.pir = this.tokenStore.number;
    this.getData();
  },
  methods: {
    // Método para obtener los datos del formulario de equipaje
    async getData() {
      this.uiStore.changeSpinner(true);
      try {
        if (!this.tokenStore.number || !this.tokenStore.pyId) {
          this.$router.back(); // Redirige a la pantalla anterior
          return;
        }
        const bf = await Api.getBaggageForm(
          this.tokenStore.number,
          this.tokenStore.pyId
        );
        this.contactId =
          bf.data?.PIR?.Passenger?.ContactId || this.tokenStore.idGolden;
        this.tokenStore.caseId = bf.data.pzInsKey;
        this.suitCases = bf.data.PIR.Baggage.map((e) => e.TAGBackup);
        this.tokenStore.idSuitCase = bf.data.PIR.Baggage.map((e) => ({
          tagBackup: e.TAGBackup,
          tagNumber: e.TAGNumber,
        }));
        this.baggageForm = true;
        this.pageStatus = this.PAGESTATUS_FORM;
        if (this.contactId === "") {
          this.setCustomError({
            customError: this.$t("error.error404"),
          });
        }
        this.uiStore.changeSpinner(false);
      } catch (e) {
        if (e.response?.status) {
          this.setCustomError({ errorCode: e.response.status });
        }
        this.uiStore.changeSpinner(false);
      }
    },
    // Método para establecer un error personalizado
    setCustomError({ errorCode, customError = "errorsSap.TPY-0100" }) {
      let error = "";
      if (!errorCode && customError) {
        error = customError;
      }
      if (errorCode) {
        let status = errorCode.toString();
        if (status.match(/^5\d{2}$/)) status = "5XX";
        error = `error.error${status}`;
        if (!this.$te(error)) error = customError;
      }
      this.uiStore.setError({
        message: this.$t(error),
      });
    },
    // Método para enviar los datos del formulario
    async submitFormData() {
      const dataClient = await this.$refs.clientFormulario.dataClientForSend;
      const dataSuitcase = await this.$refs.suitcaseFormulario
        .suitcaseDataForSend;
      const isValid =
        (await this.$refs.clientForm.validate()) &&
        // (await this.$refs.clientForm.countryConfig.name) !== "OTROS" &&
        (await this.$refs.suitcaseForm.validate());
      if (!isValid) return;
      const formData = {
        pzInsKey: this.tokenStore.caseId,
        PIR: {
          Number: this.pir,
          Baggage: Object.keys(dataSuitcase).map((d) => {
            return {
              TAGNumber: this.tokenStore.idSuitCase.find(
                (i) => i.tagBackup === d
              )?.tagNumber,
              TAGBackup: d,
              SubstitutionsFormData: {
                Brand: dataSuitcase[d]["brand"],
                Type: dataSuitcase[d]["model"],
                MaterialElement: {
                  pyValue: dataSuitcase[d]["introducedMaterial"],
                },
                Colour: dataSuitcase[d]["introducedColor"],
                Long: dataSuitcase[d]["long"],
                Width: dataSuitcase[d]["width"],
                Height: dataSuitcase[d]["high"],
                Wheels: dataSuitcase[d]["selectedWheels"],
                Description: dataSuitcase[d]["damageDescription"],
                BagDetails: dataSuitcase[d]["additionalDescription"],
                ExtendableHandles: dataSuitcase[d]["extendableHandle"],
                Closures: dataSuitcase[d]["hasClosures"],
                Zipper: dataSuitcase[d]["hasZippers"],
              },
            };
          }),
        },
        Substitutions: {
          AcceptConditions: this.conditionsCheck,
          IsTempAddress: dataClient["temporalAddress"],
          DeliveryFromDate: dataClient["fromdate"],
          DeliveryToDate: dataClient["todate"],
          Remarks: [
            {
              Value: dataClient["observations"],
            },
          ],
          Passenger: {
            pyID: this.tokenStore.idGolden,
            Name: dataClient["name"],
            Surnames: dataClient["secondName"],
            DocumentNumber: dataClient["documentation"],
            Phones: [
              {
                PhonePrefix: "+" + dataClient["mobilePrefixSelected"],
                pyPhoneNumber: parsePhoneNumber(dataClient["mobile"])
                  .nationalNumber,
                PhoneTypeList: "MOVIL",
              },
              {
                PhonePrefix: dataClient["telephonePrefixSelected"]
                  ? "+" + dataClient["telephonePrefixSelected"]
                  : null,
                pyPhoneNumber: dataClient["telephone"]
                  ? parsePhoneNumber(dataClient["telephone"]).nationalNumber
                  : null,
                PhoneTypeList: "FIJO",
              },
            ],
            Addresses: [
              {
                Country: {
                  countryname: dataClient["country"].name,
                  countryCode: dataClient["country"].value,
                },
                pyState: dataClient["provinces"],
                pyCity: dataClient["town"],
                pyStreet: dataClient["street"],
                Number: dataClient["number"],
                pyLabel: dataClient["floor"],
                pyPostalCode: dataClient["postalCode"],
              },
            ],
          },
        },
      };
      try {
        this.uiStore.changeSpinner(true);
        await Api.sendFormBaggageData(formData, this.tokenStore.pyId);
        this.submittedSuccessfully = true;
        this.pageStatus = this.PAGESTATUS_SUCCESS;
        this.uiStore.errorMsg = this.$t("errorsSap.TPY-0103");
        this.uiStore.changeSpinner(false);
      } catch (error) {
        if (error?.response?.status === 423) {
          this.setCustomError({
            customError: this.$t("errorsSap.TPY-0104"),
          });
        } else if (error?.response?.status === 406) {
          this.setCustomError({
            customError: this.$t("errorsSap.TPY-0105"),
          });
        } else if (error) {
          this.setCustomError({
            errorCode: error.response.status,
            customError: "directService.error",
          });
        }
      }
      this.uiStore.changeSpinner(false);
    },
    toggleMoreInfo() {
      this.showMoreInfo = !this.showMoreInfo;
    },
    nextStep(n) {
      if (n === this.steps) {
        this.actualStep = 1;
      } else {
        this.actualStep = n + 1;
      }
    },
    /**
     * Método para manejar la navegación entre los pasos de un proceso multietapa.
     * @param {boolean} valid - Indica si el formulario del paso actual es válido o no.
     * Comprobar si el formulario es válido antes de pasar al siguiente paso.
     * Si el formulario es válido, se pasa al siguiente paso.
     * Si el formulario no es válido, se muestra un mensaje de error.
     */
    goToNextStep(valid) {
      if (valid) {
        if (this.actualStep === 1) {
          this.actualStep = 2;
          this.showError = false;
        } else if (this.actualStep === 2) {
          this.submitFormData();
          this.showError = false;
        }
      } else {
        this.showError = true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.main-background {
  background-color: #fafafa;
}
.servicio-directo {
  margin: 0 auto;
  @media (min-width: 960px) {
    max-width: 50%;
  }

  .v-stepper {
    background-color: #fafafa;
  }
  .v-messages__message {
    line-height: 12px;
    word-break: normal;
    overflow-wrap: normal;
    word-wrap: normal;
    -webkit-hyphens: auto;
    -moz-hyphens: auto;
    -ms-hyphens: auto;
    hyphens: inherit;
  }
  .checkbox-style {
    font-size: 14px;
    margin-bottom: 16px;
    font-family: Lato Roboto;
    font-size: 14px;
    color: #565656;
  }
  .checkbox-style {
    display: flex;
    align-items: flex-start; /* Alinea verticalmente el checkbox con el texto */
    font-size: 12px !important;
    margin-bottom: -28px;
    font-family: Lato, Roboto;
    font-weight: 600 !important;
    color: #565656 !important;

    .v-checkbox {
      margin-right: 8px; /* Espacio entre el checkbox y el texto */
    }

    .checkbox-label-container {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }
  }

  .additional-info-container {
    margin-left: 16px; /* Ajusta según el espacio que desees del borde izquierdo */
  }
  .checkbox-label-text {
    margin-bottom: 0;
  }

  .more-info-link {
    font-size: 14px;
    color: #0072ce;
    cursor: pointer;
    margin-left: 12px; /* Añade el margen izquierdo al enlace */
  }

  .more-info-text-title0 {
    font-size: 14px;
    color: #707070;
    line-height: 1.5;
    font-family: Lato, -apple-system, blinkmacsystemfont, Segoe UI, Roboto,
      Helvetica Neue, arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
      Segoe UI Symbol, icomoon;
    font-weight: 600;
    margin-bottom: 0; /* Asegura que no haya margen adicional al final */
    margin-left: 12px; /* Añade el margen izquierdo al texto adicional */
    margin-top: 10px;
  }

  .more-info-text-title {
    font-size: 14px;
    color: #707070;
    line-height: 1.5;
    font-family: Lato, -apple-system, blinkmacsystemfont, Segoe UI, Roboto,
      Helvetica Neue, arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
      Segoe UI Symbol, icomoon;
    font-weight: 600;
    margin-bottom: 0; /* Asegura que no haya margen adicional al final */
    margin-left: 12px; /* Añade el margen izquierdo al texto adicional */
  }
  .more-info-text0 {
    font-size: 12px;
    color: #707070;
    line-height: 1.5;
    font-family: Lato, -apple-system, blinkmacsystemfont, Segoe UI, Roboto,
      Helvetica Neue, arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
      Segoe UI Symbol, icomoon;
    font-weight: 600;
    margin-bottom: 0; /* Asegura que no haya margen adicional al final */
    margin-left: 12px;
  }
  .more-info-text {
    font-size: 12px;
    color: #707070;
    line-height: 1.5;
    font-family: Lato, -apple-system, blinkmacsystemfont, Segoe UI, Roboto,
      Helvetica Neue, arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
      Segoe UI Symbol, icomoon;
    font-weight: 600;
    margin-bottom: 0; /* Asegura que no haya margen adicional al final */
  }
}
.alert-component {
  width: fit-content;
  box-shadow: 0px 5px 10px rgba(204, 204, 204, 0.3);
  padding: 50px;
  border-radius: 20px;
  margin: 0 auto;
}
.main-header {
  height: 150px;
  font-size: 25px;
  display: flex;
  justify-content: center;
  align-items: baseline;
  background-color: #2d69e1;
  h1 {
    font-family: AERadar;
    color: white;
    @media (max-width: 920px) {
      font-size: 40px;
    }
  }
}
.section-heading {
  color: #0f2367;
  font-family: AERadar;
  font-size: 16px;
  padding-bottom: 15px;
}
.ae-description {
  font-size: 14px;
  font-family: Lato, -apple-system, blinkmacsystemfont, Segoe UI, Roboto,
    Helvetica Neue, arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    Segoe UI Symbol, icomoon;
  margin-bottom: 16px;
  text-decoration: none;
  color: #565656;
}
.error-message {
  background: transparent;
  border: none;
  color: red;
  display: flow;
  font-size: 14px;
  line-height: 1.2;
  margin: -11px 0 0;
  display: flex;
  justify-content: center;
  align-items: baseline;
}
.alert-error {
  width: 25px;
}
.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: rgba(221, 221, 221, 2.5) !important;
}
.validation-message {
  display: flex;
  font-size: 14px;
  font-family: Lato, -apple-system, blinkmacsystemfont, Segoe UI, Roboto,
    Helvetica Neue, arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    Segoe UI Symbol, icomoon;
  font-weight: 700;
  color: #565656;
  align-items: center;
  justify-content: center;
}

.warning-text {
  font-size: 12px;
  color: #565656;
  font-weight: 600;
  line-height: 1.5;
  font-family: Lato, -apple-system, blinkmacsystemfont, Segoe UI, Roboto,
    Helvetica Neue, arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    Segoe UI Symbol, icomoon;
  padding: 40px;
  text-align: justify;
}
</style>
